"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.divider = exports.icon = exports.scripName = exports.container = exports.root = void 0;

var _util = require("../../../util");

const root = ({
  theme
}) => ({
  background: (0, _util.color)(theme, 'interactive.ticker.default'),
  borderRadius: 4,
  cursor: 'pointer',
  height: 40,
  position: 'relative',
  transition: 'background 0.2s ease',
  ':active': {
    background: (0, _util.color)(theme, 'interactive.ui.active')
  },
  ':hover': {
    background: (0, _util.color)(theme, 'interactive.ticker.hover')
  }
});

exports.root = root;

const container = () => ({
  whiteSpace: 'nowrap'
});

exports.container = container;

const scripName = () => ({
  whiteSpace: 'nowrap'
});

exports.scripName = scripName;

const icon = ({
  theme
}) => ({
  margin: (0, _util.spacing)(theme, ['none', 'xxsmall', 'none', 'none'])
});

exports.icon = icon;

const divider = ({
  theme
}) => ({
  display: 'block',
  color: (0, _util.color)(theme, 'ui4'),
  fontSize: 10,
  padding: (0, _util.spacing)(theme, ['none', 'medium'])
});

exports.divider = divider;
//# sourceMappingURL=TickerElement.style.js.map